<p *ngIf="!hide && show" class="alert-danger">
  <i class="icon-cnt-times-circle"></i>
  <span *ngIf="field" class="font-weight-bold">{{ field }}:</span>
  {{ _text }}
</p>
